<template>
    <section class="all-v">
        <div class="auth-form">
            <h1 :style="theme.header">Sign Up</h1>

            <div class="text-left">
                <label class="label-mini" for="firstName">First Name</label>
                <input name="first name" class="form-control w-input" placeholder="First Name" id="firstName" autofocus
                       v-validate="'required'" :class="{ 'is-invalid': errors.has('first name') }" v-model.trim="firstname"/>
                <small class="text-danger" v-if="errors.has('first name')">{{ errors.first('first name') }}</small>
            </div>
            <div class="text-left">
                <label class="label-mini" for="lastName">Last Name</label>
                <input name="last name" class="form-control w-input" placeholder="Last Name" id="lastName"
                       v-validate="'required'" :class="{ 'is-invalid': errors.has('last name') }" v-model.trim="lastname"/>
                <small class="text-danger" v-if="errors.has('last name')">{{ errors.first('last name') }}</small>
            </div>
            <div class="text-left">
                <label class="label-mini" for="phoneNumber">Phone Number</label>
                <input name="phone number" class="form-control w-input" placeholder="Phone Number" id="phoneNumber"
                       v-validate :class="{ 'is-invalid': errors.has('phone number') }" v-model.trim="phone_number"
                       v-mask="'+1 (###) ### - ####'" :masked="true" @keydown="phoneChanged">
                <small class="text-danger" v-if="errors.has('phone number')">{{ errors.first('phone number') }}</small>
            </div>
            <div class="text-left">
                <label class="label-mini" for="email">Email</label>
                <input type="email" name="email" class="form-control w-input" placeholder="Email" id="email"
                       v-validate="'required'" :class="{ 'is-invalid': errors.has('email') }" v-model.trim="email"/>
                <small class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</small>
            </div>
            <div class="text-left">
                <label class="label-mini" for="password">Password</label>
                <input name="password" class="form-control w-input" placeholder="Password" id="password"
                       v-validate="{ required: true, regex: '[\\S].{4,96}[\\S]' }" :class="{ 'is-invalid': errors.has('password') }" v-model="password"
                       :type="showPass ? '' : 'password'"/>
                <small class="text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</small>
            </div>
            <div class="mt-3 cursor-pointer text-left" @click="showPass = !showPass">
                <span v-if="!showPass"><i class="fa fa-eye"></i> Show</span>
                <span v-if="showPass"><i class="fa fa-eye-slash"></i> Hide</span>
            </div>
            <div class="alert alert-danger" v-if="awsMessage">
                {{ awsMessage }}
            </div>

            <div :style="theme.actionRowSignin">
                <w-button :inverse="true" id="submit-btn" @click="signUp" class="px-4">Sign Up</w-button>
            </div>
            <div class="auth-form-footer">
                <div>
                    <a :style="theme.link" id="back-signin" @click="signIn">Back to Sign In</a>
                </div>
                <div>
                    <a :style="theme.link" @click="confirm">Confirm Code</a>
                </div>
            </div>
        </div>
        <w-version/>
    </section>
</template>

<script>
import { Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import AmplifyTheme from '../../style/AmplifyTheme'

const logger = new Logger('SignUpComp')

export default {
    name: 'SignUp',
    data () {
        return {
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            phone_number: '+1',
            theme: AmplifyTheme,
            awsMessage: '',
            showPass: false
        }
    },
    computed: {
        user () {
            return this.$store.getters['auth/user']
        }
    },
    methods: {
        phoneChanged (e) {
            e.target.value = '+1 ' + this.phone_number.slice(3)
            if (e.target.value.length < 3) e.preventDefault()
        },
        signUp () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.awsMessage = ''
                    let params = {
                        username: this.randomUsername(),
                        password: this.password,
                        attributes: {
                            email: this.email.toLowerCase().trim(),
                            given_name: this.firstname.trim(),
                            family_name: this.lastname.trim()
                        }
                    }

                    Auth.signUp(params).then(data => {
                        logger.debug('sign up success', data)
                        this.$store.commit('auth/tempUserName', data.user.username)
                        this.$router.push('/auth/confirmSignUp').catch(err => err)
                    }).catch(err => {
                        this.awsMessage = err.message
                        logger.error('sign up error', err)
                    })
                }
            })
        },
        signIn () {
            this.$router.push('/auth/signIn')
        },
        confirm () {
            this.$router.push('/auth/confirmSignUp').catch(err => err)
        },
        createUserName () {
            let data = new Date()
            let n = data.getTime()
            return this.firstname + this.lastname + '-' + n.toString().substr(7, 6)
        },

        randomUsername () {
            const USERID_PREFIX = 'WG_'
            let d = new Date().getTime()
            let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                let r = ((d + Math.random() * 16) % 16) | 0
                d = Math.floor(d / 16)
                return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
            })
            return USERID_PREFIX + uuid
        }
    },
    mounted () {
        if (this.$route.query.redirect) {
            this.$store.dispatch('auth/setSignUpRedirectPath', this.$route.query.redirect)
        }
        this.$validator.localize('en', {
            custom: {
                password: {
                    regex: 'Please enter at least 6 alphanumeric characters.',
                    required: 'Please enter at least 6 alphanumeric characters.'
                }
            }
        })
    }
}
</script>

<style scoped>

    h1 {
        font-size: 28px !important;
        font-weight: 500 !important;
        color: #1a3f65 !important;
    }

    .auth-form {
        display: inline-block;
        width: 320px;
        margin-top: 85px;
        padding-top: 15px;
    }

    .auth-form-footer {
        display: flex;
        margin-top: 1em;
        justify-content: space-between;
    }

    .auth-form-footer a {
        color: #23B8DC;
    }

    @media (max-width: 576px) {
        .all-v {
            padding-left: 17px;
            padding-right: 17px;
        }

        .auth-form {
            display: block;
            width: 100%;
            max-width: 320px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
